import D from './contact-channels214.js';
import x from './contact-channels215.js';
import C from './contact-channels79.js';
import { MAX_LENGTH_COUNTRY_CODE as E } from './contact-channels197.js';

function p(r,o,f,i){if(!r)return {};var n;if(r[0]!=="+"){var l=D(r,o,f,i);if(l&&l!==r)n=true,r="+"+l;else {if(o||f){var _=x(r,o,f,i),C$1=_.countryCallingCode,N=_.number;if(C$1)return {countryCallingCodeSource:"FROM_NUMBER_WITHOUT_PLUS_SIGN",countryCallingCode:C$1,number:N}}return {number:r}}}if(r[1]==="0")return {};i=new C(i);for(var e=2;e-1<=E&&e<=r.length;){var t=r.slice(1,e);if(i.hasCallingCode(t))return i.selectNumberingPlan(t),{countryCallingCodeSource:n?"FROM_NUMBER_WITH_IDD":"FROM_NUMBER_WITH_PLUS_SIGN",countryCallingCode:t,number:r.slice(e)};e++;}return {}}

export { p as default };
//# sourceMappingURL=contact-channels179.js.map
